export const RAFFLE_CONTRACT_ADDRESS = "0x48A3A107FcC2DaCDbfc7dA19e5343cA83794D617";
